import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VSL } from './components/VSL';
import { Reviews } from './components/Reviews';
import { Process } from './components/Process';
import { Commitment } from './components/Commitment';
import { Services } from './components/Services';
import { FAQ } from './components/FAQ';
import { Booking } from './components/Booking';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0" data-mp="2mn5a0exnchfn">
      <Navbar data-id="element-1" data-mp="31bi8bik7icdb" />
      <main data-id="element-2" data-mp="31c1igd3m7wgs">
        <Hero data-id="element-3" data-mp="31cjn9y4cfj0b" />
        <VSL data-id="element-4" data-mp="2wk06ksad07ra" />
        <Reviews data-id="element-5" data-mp="2wjgp1comflds" />
        <Process data-id="element-6" data-mp="2wiywaq163pam" />
        <Commitment data-id="element-7" data-mp="2wifgbev2vaz8" />
        <Services data-id="element-8" data-mp="2whxaprmizken" />
        <FAQ data-id="element-9" data-mp="28ufmg62gz4gf" />
        <Booking data-id="element-10" data-mp="28tw4wqgqei2x" />
        <CTA data-id="element-11" data-mp="28te2td7e19n3" />
      </main>
      <Footer data-id="element-12" data-mp="28sl3uyeo7ofi" />
    </div>;
}